import axios from "axios";

import { BASE_URL_PUBLISHING_API } from "../config";

export const publishingApi = axios.create({
  baseURL: BASE_URL_PUBLISHING_API,
  headers: {
    "Content-Type": "application/json",
  },
});
